import { AlpineComponent } from "alpinejs";
import { PasswordResetService } from "../api";

const toErrorMessage = (error: string | { errorMessage?: string | null }): string => {
	if (typeof error === "string") {
		return error;
	}

	return error.errorMessage ?? "Unknown error";
};

type ForgotPassword = AlpineComponent<{
	email: string;
	showErrorMessage: boolean;
	showSuccessMessage: boolean;
	submissionErrors: string[];
	sendEmail: () => void;
}>;

export default (): ForgotPassword => {
	return {
		email: "",
		showErrorMessage: false,
		showSuccessMessage: false,
		submissionErrors: [],
		async sendEmail() {
			const response = await PasswordResetService.sendPasswordResetMail({ body: { email: this.email } });
			this.submissionErrors = [];
			if (response.response.status !== 200 && response.error != null) {
				for (const error of response.error) {
					this.submissionErrors.push(toErrorMessage(error));
				}
				this.showErrorMessage = true;
				this.showSuccessMessage = false;
			} else {
				this.showSuccessMessage = true;
				this.showErrorMessage = false;
			}
		},
	};
};
